<template>
	<div>
		<div v-if="this.params.data.custom_tag_id" class="d-flex text-center">			
			<vx-tooltip :text="`${this.params.data.customtag.comments}`" position="bottom" >
				{{this.params.data.customtag.tag_name}}
			</vx-tooltip>
		</div>			
		<div v-else class="d-flex text-center">
			<p>null</p>
		</div>			
	</div>	
</template>

<script>
	
	export default {
		name: 'CellRendererCustomTagComments',	 
		data() {
			return {  				 
			}
		},
        computed: {  			
		},
	}
</script>
<style lang="scss">
	.vs-tooltip {
		text-align: center;
	}
</style>